"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1463],{

/***/ 21463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ WeAreHeycater; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/weareheycater.jpeg
/* harmony default export */ var weareheycater = ({"src":"/_next/static/media/weareheycater.1060bca4.jpeg","height":900,"width":1102,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAHAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAdEAACAgIDAQAAAAAAAAAAAAABAgAEAxEFEiIx/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AI/AtWxY0sPbsUyyHKOnsNiTYba/CdiIiB//2Q==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/WeAreHeycater.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 34.5px;\n  ",
        " {\n    font-size: 36px;\n    line-height: 62.1px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 27.6px;\n  margin-top: ",
        "px;\n  ",
        " {\n    font-size: 24px;\n    line-height: 41.4px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  line-height: 23.52px;\n  margin: ",
        ";\n  ",
        " {\n    font-size: 16px;\n    line-height: 26.88px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 47px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: column;\n  margin: auto;\n  padding: ",
        ";\n  gap: 40px;\n  ",
        " {\n    flex-direction: row;\n    width: fill-available !important;\n    max-width: 1118px !important;\n    padding: 0;\n    gap: auto;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 578px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    border-radius: 20px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







function WeAreHeycater() {
    var t = (0,useTranslation/* useTranslation */.$)("homepage").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WeAreHeycaterLeftBox, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: t("weAreHeycater.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subttitle, {
                        children: t("weAreHeycater.subtitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                        children: t("weAreHeycater.body")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.heycater.com/de/about-us",
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                            variant: "tertiary",
                            children: t("weAreHeycater.cta")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WeAreHeycaterRightBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: weareheycater,
                    height: 374,
                    width: 460,
                    quality: 100
                })
            })
        ]
    });
}
var Title = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Subttitle = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Paragraph = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing(2, 0);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var StyledButton = (0,styled_components_browser_esm["default"])(esm.Button)(_templateObject3());
var Wrapper = styled_components_browser_esm["default"].div(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.spacing(0, 2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var WeAreHeycaterLeftBox = styled_components_browser_esm["default"].div(_templateObject5());
var WeAreHeycaterRightBox = styled_components_browser_esm["default"].div(_templateObject6());


/***/ })

}]);